import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import AppContainer from './containers/appContainer'
import LoginContainer from './containers/login'

import { getAccessToken } from './containers/appContainer/actions'
import { isStaging, routePrefix } from './config'

import store from './store'
import * as serviceWorker from './serviceWorker'
import moment from 'moment';

import BusLoadingComponent from './components/busLoading'

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './index.css'
export const USER_INFO = 'sessionValue';

const CaptureTokenComponent = (props) => {
  const params = new URLSearchParams(props.location.search || '');
  const code = params.get('code');
  if(code) {
    getAccessToken(code, store.dispatch)
      .then(res => {
        if(res && res.status === 200) {
          props.history.push(routePrefix + '/');
        } else {
          props.history.push(routePrefix + '/login');
        }
        window.location.reload();
      });
    return <BusLoadingComponent />;
  }
  // some issue, didn't get token from backend, redirect back to login page
  props.history.push(routePrefix + '/login');
  // add some loading icon
  return null;
}

const addOauthSDKScript = () => {
  const script = document.createElement('script');
  script.innerHTML = `(function(w, d, q, o, t, s, f, se, js, fjs) {
    w[o]=w[o]||{init:function(){w[o][q]=arguments}}
    js=d.createElement(s),fjs=d.getElementsByTagName(s)[0]
    js.type=t;js.async=1;js.src=f;fjs.parentNode.insertBefore(js,fjs);
  })(window, document, '_beforeLoadConfig', 'Oauth', 'text/javascript', 'script', \`https://accounts${
    isStaging ? "-staging." : "."
  }paytm${
    isStaging ? ".in" : ".com"
  }/oauth-js-sdk/shim/bundle.js\`);`
  document.head.appendChild(script);
};

const captureSSOToken = () => {
  const windowElem = window.top.document.getElementsByTagName('body')[0];
  let eventAttached = false;
  if (!eventAttached) {
    eventAttached = !eventAttached;
    windowElem.addEventListener('auth-response', (event) => {
      const userData = event.data;
      // localStorage.setItem('auth_response_evt', JSON.stringify(event));
      localStorage.setItem(USER_INFO, JSON.stringify(userData));
      localStorage.setItem('PaytmTravelLoginFetched', JSON.stringify(moment()));
      const sso_token_enc = userData && userData.user && userData.user.sso_token_enc;
      if(sso_token_enc) {
        getAccessToken(sso_token_enc, store.dispatch)
          .then(res => {
            if(res && res.status === 200) {
              console.log('push to /')
              this.props.history.push(routePrefix + '/');
            } else {
              console.log('push to /login')
              this.props.history.push(routePrefix + '/login');
            }
            window.location.reload();
          });
        // return <BusLoadingComponent />;
      }
    });
  }
}

function App() {
  console.log("Running from staging branch");
  useEffect(() => {
    addOauthSDKScript();
    captureSSOToken();
  }, [])
  return (
    <Provider store={store}>
      <Router>
        <div>
          <Switch>
            <Route exact path={`${routePrefix}/login`} component={LoginContainer} />
            {/* <Route exact path={`${routePrefix}/code`} component={CaptureTokenComponent} /> */}
            <Route path={routePrefix || '/'} component={AppContainer} />
          </Switch>
        </div>
      </Router>
    </Provider>
  );
}


ReactDOM.render(
  <App />,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
